import { resolvePublicPath } from 'client/core/appConfig';
import { ISpidProviderButton } from './SpidLoginButton';

const arubaId = require('./img/spid-idp-arubaid.svg').default;
const infocertId = require('./img/spid-idp-infocertid.svg').default;
const intesaId = require('./img/spid-idp-intesaid.svg').default;
const lepidaId = require('./img/spid-idp-lepidaid.svg').default;
const namirialId = require('./img/spid-idp-namirialid.svg').default;
const posteId = require('./img/spid-idp-posteid.svg').default;
const spidItalia = require('./img/spid-idp-spiditalia.svg').default;
const sielteId = require('./img/spid-idp-sielteid.svg').default;
const timId = require('./img/spid-idp-timid.svg').default;
const teamsystemId = require('./img/spid-idp-teamsystemid.svg').default;

/**
 * Lista dei provider SPID statici
 */
export const staticSpidProviders: ISpidProviderButton[] = [
  {
    organization_name: 'ArubaPEC S.p.A.',
    entity_id: 'https://loginspid.aruba.it',
    logo_uri: resolvePublicPath(arubaId)
  },
  {
    organization_name: 'InfoCert S.p.A.',
    entity_id: 'https://identity.infocert.it',
    logo_uri: resolvePublicPath(infocertId)
  },
  {
    organization_name: 'IN.TE.S.A. S.p.A.',
    entity_id: 'https://spid.intesa.it',
    logo_uri: resolvePublicPath(intesaId)
  },
  {
    organization_name: 'Lepida S.p.A.',
    entity_id: 'https://id.lepida.it/idp/shibboleth',
    logo_uri: resolvePublicPath(lepidaId)
  },
  {
    organization_name: 'Namirial',
    entity_id: 'https://idp.namirialtsp.com/idp',
    logo_uri: resolvePublicPath(namirialId)
  },
  {
    organization_name: 'Poste Italiane SpA',
    entity_id: 'https://posteid.poste.it',
    logo_uri: resolvePublicPath(posteId)
  },
  {
    organization_name: 'Sielte S.p.A.',
    entity_id: 'https://identity.sieltecloud.it',
    logo_uri: resolvePublicPath(sielteId)
  },
  {
    organization_name: 'Register.it S.p.A.',
    entity_id: 'https://spid.register.it',
    logo_uri: resolvePublicPath(spidItalia)
  },
  {
    organization_name: 'TI Trust Technologies srl',
    entity_id: 'https://login.id.tim.it/affwebservices/public/saml2sso',
    logo_uri: resolvePublicPath(timId)
  },
  {
    organization_name: 'TeamSystem s.p.a.',
    entity_id: 'https://spid.teamsystem.com/idp',
    logo_uri: resolvePublicPath(teamsystemId)
  }
];
